var React = require('react');

function IconVimeo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.363.006Q16.9-.185 14.967 6.468a4.87 4.87 0 0 1 1.939-.434q1.993 0 1.758 2.364a10.24 10.24 0 0 1-1.584 4.235c-1.1 1.824-1.507 2.9-2.753 2.9s-1.234-1.644-1.827-4.458q-.3-1.244-1.054-6.343Q10.738.004 7.691.314 6.4.438 3.82 2.801 1.939 4.606 0 6.409l1.231 1.679a7.993 7.993 0 0 1 2.053-1.3c.9 0 1.7.984 2.525 4.473.633 2.757 1.409 5.474 2.115 8.21 1.05 2.982 2.347 4.475 3.871 4.475q3.7 0 9.041-7.334Q26 9.583 26.177 5.539 26.419.131 22.363.006z"}));
}

IconVimeo.defaultProps = {"viewBox":"0 0 26.19 23.941"};

module.exports = IconVimeo;

IconVimeo.default = IconVimeo;
